/** Copyright (c) 2018 T.Rowe Price. All rights reserved. */

import './LogoutPage.scss';

import React from 'react';
import { uniq } from 'lodash';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { logoutUrl } from 'services/Externals';
import { getProducts } from 'services/Products';
import { getView } from 'state/view/ViewSelectors';
import { GLOBALS } from 'services/globals';
import PageLoadingSpinner from 'components/layouts/Navigation/PageLoadingSpinner';
import { removeBrowserCookie } from 'support/BrowserUtils';
import { getNonPurgedAccounts } from 'state/account/AccountSelectors';

class LogoutPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      time: 0,
      vendorLoaded: false,
      logoutSrc: `${GLOBALS.AAM_UI_BROKERAGE_BASE_URL}/c/portal/logout`,
      ssoSrc: `${GLOBALS.AAM_UI_BROKERAGE_BASE_URL}/web/troweprice/sso-logout?message=logout&errorCode=null`
    };
  }

  componentDidMount() {
    // log out of pershing MFE
    if (window && window.pershingMFEHelper) {
      window.pershingMFEHelper.logout();
    }
    let { time: timer } = this.state;
    this.interval = setInterval(
      () => this.setState({ time: (timer += 1) }),
      1000
    );
    removeBrowserCookie('additionalParams');
    const component = this;
    const logoutFrame = document.getElementById('pershLogoutFrame');
    if (logoutFrame) {
      logoutFrame.addEventListener('load', function () {
        const docItems = Object.keys(this.contentWindow.document);
        if (docItems.length) {
          component.setVendorLoaded(true);
        }
      });
    }

    const ssoFrame = document.getElementById('pershSSOFrame');
    if (ssoFrame) {
      ssoFrame.addEventListener('load', function () {
        const docItems = Object.keys(this.contentWindow.document);
        if (docItems.length) {
          component.setVendorLoaded(true);
        }
      });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (!prevState.vendorLoaded && this.state.vendorLoaded) {
      if (window && window.location && window.location.replace) {
        console.log('Redirecting to logout');
        const products = uniq(getProducts(this.props.accounts));
        window.location.replace(logoutUrl(products));
      }
    }
  }

  componentWillUnmount() {
    const { accounts } = this.props;
    clearInterval(this.interval);
    const products = uniq(getProducts(accounts));
    if (window && window.location && window.location.replace) {
      window.location.replace(logoutUrl(products));
    }
  }

  setVendorLoaded(value) {
    this.setState({ vendorLoaded: value });
  }

  render() {
    const { accounts, forceLogout = false } = this.props;
    const { logoutSrc, ssoSrc, time } = this.state;

    if (forceLogout) {
      const products = uniq(getProducts(accounts));
      if (window && window.location && window.location.replace) {
        window.location.replace(logoutUrl(products));
      }
      return (
        <>
          <per-mfe-shell initialsettings={`{"environment": "xat", "ibd": "30A", "platform": "retail"}`}></per-mfe-shell>
          <Link
            rel="canonical"
            to={() => {
              if (window && window.location && window.location.href) {
                window.location.href = logoutUrl(products);
              }
              return window.open(logoutUrl(products), '_self');
            }}
          />
        </>
      );
    }

    if (time >= 15) {
      const products = uniq(getProducts(accounts));
      if (window && window.location && window.location.replace) {
        window.location.replace(logoutUrl(products));
      }
      return window.open(logoutUrl(products), '_self');
    }
    return (
      <div>
        <per-mfe-shell initialsettings={`{"environment": "xat", "ibd": "30A", "platform": "retail"}`}></per-mfe-shell>
        <PageLoadingSpinner name="Logging out..." override />
        <iframe
          hidden
          id="logoutFrame"
          name="logoutFrame"
          style={{
            top: 0,
            left: 0,
            width: 0,
            height: 0
          }}
        />
        <iframe
          hidden
          id="pershLogoutFrame"
          name="pershLogoutFrame"
          src={logoutSrc}
          style={{
            top: 0,
            left: 0,
            width: 0,
            height: 0
          }}
        />
        <iframe
          hidden
          id="pershSSOFrame"
          name="pershSSOFrame"
          src={ssoSrc}
          style={{
            top: 0,
            left: 0,
            width: 0,
            height: 0
          }}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  accounts: getNonPurgedAccounts(state),
  view: getView(state)
});

export default withRouter(connect(mapStateToProps)(LogoutPage));
